import Axios from "axios";
import { ApiResultModel } from "../../models/common.model";
import { ApiBaseUrl, StoreUrl } from "../../config/config";
import {
  CartItemRequest,
  DeleteCartItemResponse,
  FinalizerOrderItemsRequest,
  GetCartInfoResponse,
  GetProductDetailResponse,
  GetProductPriceInfoRequest,
  GetProductsCategoryRequest,
  GetProductsCategoryResponse,
  GetProductsRequest,
  GetProductsResponse,
  HistoryListRequest,
  HistoryListResponse,
  OpenOrder,
  ProductKey,
  SearchProductsResponse,
  StoreResponse,
} from "../models/store.model";

export const GetProducts = (
  data: GetProductsRequest
): Promise<ApiResultModel<GetProductsResponse>> => {
  return Axios.post<ApiResultModel<GetProductsResponse>>(
    ApiBaseUrl + StoreUrl + "/GetProducts",
    data
  ).then((result) => {
    return result.data;
  });
};
// export const SearchProducts = (
//   data: GetProductsRequest
// ): Promise<ApiResultModel<SearchProductsResponse[]>> => {
//   return Axios.post<ApiResultModel<SearchProductsResponse[]>>(
//     ApiBaseUrl + StoreUrl + "/SearchProducts",
//     data
//   ).then((result) => {
//     return result.data.data;
//   });
// };

export const SearchProducts = async (
  data: GetProductsRequest
): Promise<SearchProductsResponse> => {
  return await Axios.post<ApiResultModel<SearchProductsResponse>>(
    ApiBaseUrl + StoreUrl + "/SearchProducts",

    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetProductCategory = (
  data: GetProductsCategoryRequest
): Promise<ApiResultModel<GetProductsCategoryResponse>> => {
  return Axios.post<ApiResultModel<GetProductsCategoryResponse>>(
    ApiBaseUrl + StoreUrl + "/GetProductCategory",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCartInfo = (): Promise<ApiResultModel<GetCartInfoResponse>> => {
  return Axios.post<ApiResultModel<GetCartInfoResponse>>(
    ApiBaseUrl + StoreUrl + "/GetCartInfo"
  ).then((result) => {
    return result.data;
  });
};

export const DeleteCartItem = (
  data: CartItemRequest
): Promise<ApiResultModel<StoreResponse>> => {
  return Axios.post<ApiResultModel<StoreResponse>>(
    ApiBaseUrl + StoreUrl + "/DeleteCartItem",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetProductDetail = (
  data: ProductKey
): Promise<ApiResultModel<GetProductDetailResponse>> => {
  return Axios.post<ApiResultModel<GetProductDetailResponse>>(
    ApiBaseUrl + StoreUrl + "/GetProductDetail",
    data
  ).then((result) => {
    return result.data;
  });
};

export const FinalizerOrderItems = (
  data: FinalizerOrderItemsRequest
): Promise<ApiResultModel<StoreResponse[]>> => {
  return Axios.post<ApiResultModel<StoreResponse[]>>(
    ApiBaseUrl + StoreUrl + "/FinalizeOrderItems",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetProductPriceInfo = (
  data: GetProductPriceInfoRequest
): Promise<ApiResultModel<OpenOrder>> => {
  return Axios.post<ApiResultModel<OpenOrder>>(
    ApiBaseUrl + StoreUrl + "/GetProductPriceInfo",

    data
  ).then((result) => {
    return result.data;
  });
};

export const RegisterOrder = (
  data: GetProductPriceInfoRequest
): Promise<ApiResultModel<StoreResponse>> => {
  return Axios.post<ApiResultModel<StoreResponse>>(
    ApiBaseUrl + StoreUrl + "/RegisterOrder",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCartSummary = (): Promise<ApiResultModel<number>> => {
  return Axios.post<ApiResultModel<number>>(
    ApiBaseUrl + StoreUrl + "/GetCartSummary"
  ).then((result) => {
    return result.data;
  });
};

export const GetInProgressOrders = (
  data: HistoryListRequest
): Promise<ApiResultModel<HistoryListResponse[]>> => {
  return Axios.post<ApiResultModel<HistoryListResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetInProgressOrders",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetDeliveredOrders = (
  data: HistoryListRequest
): Promise<ApiResultModel<HistoryListResponse[]>> => {
  return Axios.post<ApiResultModel<HistoryListResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetDeliveredOrders",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCanceledOrders = (
  data: HistoryListRequest
): Promise<ApiResultModel<HistoryListResponse[]>> => {
  return Axios.post<ApiResultModel<HistoryListResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetCanceledOrders",
    data
  ).then((result) => {
    return result.data;
  });
};
